export default __webpack_public_path__ + "static/media/sweet3.f92d993d.jpg";